export const watchos = {
  id: 'watchos',
  label: 'watchOS',
  emoji: '⌚',
  colorScheme: 'orange',
  description: 'Apple Watch icons',
  folder: 'watchos/AppIcon.appiconset',
  icons: [
    // Notification Center
    { filename: 'Icon-notif-38mm@2x.png',  size: 48,  pointSize: 24,  scale: 2, idiom: 'watch', role: 'notificationCenter', label: 'Notification 38mm @2x' },
    { filename: 'Icon-notif-42mm@2x.png',  size: 55,  pointSize: 27.5,scale: 2, idiom: 'watch', role: 'notificationCenter', label: 'Notification 42mm @2x' },
    // Companion Settings
    { filename: 'Icon-settings@2x.png',    size: 58,  pointSize: 29,  scale: 2, idiom: 'watch', role: 'companionSettings', label: 'Settings @2x' },
    { filename: 'Icon-settings@3x.png',    size: 87,  pointSize: 29,  scale: 3, idiom: 'watch', role: 'companionSettings', label: 'Settings @3x' },
    // Home Screen (38mm)
    { filename: 'Icon-home-38mm@2x.png',   size: 80,  pointSize: 40,  scale: 2, idiom: 'watch', role: 'appLauncher',       label: 'Home 38mm @2x' },
    // Home Screen (40mm / 41mm)
    { filename: 'Icon-home-40mm@2x.png',   size: 88,  pointSize: 44,  scale: 2, idiom: 'watch', role: 'appLauncher',       label: 'Home 40mm @2x' },
    // Home Screen (44mm / 45mm)
    { filename: 'Icon-home-44mm@2x.png',   size: 100, pointSize: 50,  scale: 2, idiom: 'watch', role: 'appLauncher',       label: 'Home 44mm @2x' },
    // Short Look (38mm)
    { filename: 'Icon-shortlook-38mm@2x.png', size: 172, pointSize: 86, scale: 2, idiom: 'watch', role: 'quickLook',      label: 'Short Look 38mm @2x' },
    // Short Look (42mm)
    { filename: 'Icon-shortlook-42mm@2x.png', size: 196, pointSize: 98, scale: 2, idiom: 'watch', role: 'quickLook',      label: 'Short Look 42mm @2x' },
    // App Store
    { filename: 'Icon-1024.png',            size: 1024,pointSize: 1024,scale: 1, idiom: 'watch-marketing',                label: 'App Store' },
  ],
  generateContentsJson(appName = 'AppIcon') {
    return {
      images: this.icons.map((icon) => ({
        filename: icon.filename,
        idiom: icon.idiom,
        role: icon.role,
        scale: `${icon.scale}x`,
        size: `${icon.pointSize}x${icon.pointSize}`,
      })),
      info: { version: 1, author: 'xcode' },
    };
  },
};
